import { useMutation } from '@tanstack/react-query';
import { impersonationService } from '../../services/impersonationService';
import { ImpersonationMode, StartImpersonationResponse } from '../../types/Impersonation';

interface StartImpersonationParams {
  userId: number;
  mode?: ImpersonationMode;
}

export const useStartImpersonation = () => {
  return useMutation<StartImpersonationResponse, Error, StartImpersonationParams>({
    mutationFn: ({ userId, mode }) =>
      impersonationService.startImpersonation(userId, mode),
  });
};
